// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
// core components
import styles from "assets/jss/style-component/views/formInput.js";
import { Card, CardBody, CardHeaderForm } from "components";
// nodejs library to set properties for components
import PropTypes from "prop-types";
import React from "react";


const useStyles = makeStyles(styles);

export default function CardComplete(props) {
  const classes = useStyles();

  const { titulo, children, onlyTitulo, marginTop, sinTitulo } = props;

  return (
    <div>
      {marginTop && (<div><br/><br /></div>)}
      {onlyTitulo && (
        <CardHeaderForm color="success">
          <h4 className={classes.cardTitleWhite}> {titulo}</h4>
        </CardHeaderForm>
      )}
      {!onlyTitulo && !sinTitulo && (<Card>
        <CardHeaderForm color="rose">
          <h4 className={classes.cardTitleWhite}> {titulo}</h4>
        </CardHeaderForm>
        <CardBody> {children} </CardBody>
      </Card>)}
      {!onlyTitulo && sinTitulo && (<Card> 
        <CardBody> {children} </CardBody>
      </Card>)}
    </div>
  );
}

CardComplete.propTypes = {
  titulo: PropTypes.string,
  children: PropTypes.node
};
